import * as types from './types';

const INITIAL_STATE = {
  loading: false,
  saveSuccessful: false,
  error: null,
  negativeAccounts: null,
  showDialog: false,
  showNoDataDialog: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.ZERO_NEGATIVE_BALANCES_SET_SAVE_SUCCESSFULL:
      return { ...state, saveSuccessful: payload };

    case types.ZERO_NEGATIVE_BALANCES_LOADING:
      return { ...state, loading: payload };

    case types.ZERO_OUT_BALANCES_SET_ERROR:
      return { ...state, error: payload };

    case types.ZERO_OUT_NEGATIVE_BALANCES_GET_NEGATIVE_BALANCES:
      return {
        ...state,
        negativeAccounts: payload,
        showNoDataDialog: payload === 0,
        showDialog: payload > 0,
      };
    case types.ZERO_NEGATIVE_BALANCES_NO_DATA_DIALOG:
      return {
        ...state,
        showNoDataDialog: payload,
      };

    case types.ZERO_OUT_NEGATIVE_BALANCES:
      return { ...state, negativeAccounts: null };

    case types.ZERO_NEGATIVE_BALANCES_DIALOG:
      return { ...state, showDialog: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/zeroNegativeBalance/reducer.js